import { BASE_URL, BUSINESS_NAME } from "@/core/constants/business";

export const META = {
  title: `Refund Policy | ${BUSINESS_NAME}`,
  meta_description: `Learn about ${BUSINESS_NAME}'s refund policy for cannabis products at our Washington DC dispensary. Understanding our product returns, exchanges, and refund procedures.`,
  canonicalUrl: "/refund-policy",
  keywords: `${BUSINESS_NAME} refund policy, cannabis refund policy, DC dispensary returns, marijuana product exchanges, cannabis quality guarantee, dispensary product policy, return policy cannabis products`,
};

export const generateRefundPolicyRichSnippet = () => {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${BASE_URL}/refund-policy/#webpage`,
    url: `${BASE_URL}/refund-policy/`,
    name: META.title,
    description: META.meta_description,
    isPartOf: {
      "@id": `${BASE_URL}/#website`,
    },
    about: {
      "@type": "Organization",
      name: BUSINESS_NAME,
      url: BASE_URL,
    },
    mainContentOfPage: {
      "@type": "WebPageElement",
      cssSelector: ".refund-policy-content",
    },
    speakable: {
      "@type": "SpeakableSpecification",
      cssSelector: ["h1", "h2", ".refund-policy-intro"],
    },
  };
};
